var map = {
	"./br/appstore.png": 63207,
	"./en/appstore.png": 91508,
	"./fr/appstore.png": 21267,
	"./ge/appstore.png": 38527,
	"./la/appstore.png": 96372,
	"./tw/appstore.png": 35898,
	"./zh/appstore.png": 56153
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30640;